export default "__VITE_ASSET__DoL9dprT__"